import { createSlice } from "@reduxjs/toolkit"
import {
  createInterviewSchedule,
  getAssessmentList,
  getInterviewQuestions,
  getInterviewsScheduleList,
  getMatchedCandidatesList,
  submitInterviewAssessment,
} from "store/actions/interviewsAction"

const initialState = {
  loading: false,
  loading2: false,
  loadingInterviewQ: false,
  isLoading: false,
  interviewsList: [],
  assessmentsList: [],
  matchedCandidatesList: [],
  interviewQuestions: [],
  totalAllowTime: null,
}

const usersSlice = createSlice({
  name: "interview schedule", //
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getInterviewsScheduleList.pending, state => {
        state.loading = true
      })
      .addCase(getInterviewsScheduleList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.interviewsList = data
        }
      })
      .addCase(getInterviewsScheduleList.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(getMatchedCandidatesList.pending, state => {
        state.loading2 = true
      })
      .addCase(getMatchedCandidatesList.fulfilled, (state, action) => {
        state.loading2 = false
        const { success, data } = action.payload
        if (success) {
          const { totalCount, total_records, currentPage } = action.payload
          // console.log(data)
          state.matchedCandidatesList = data
          state.totalCount = total_records
        }
      })
      .addCase(getMatchedCandidatesList.rejected, (state, action) => {
        state.loading2 = false
      })

    builder
      .addCase(createInterviewSchedule.pending, state => {
        state.isLoading = true
      })
      .addCase(createInterviewSchedule.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createInterviewSchedule.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(getAssessmentList.pending, state => {
        state.loading = true
      })
      .addCase(getAssessmentList.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.assessmentsList = data
        }
      })
      .addCase(getAssessmentList.rejected, (state, action) => {
        state.loading = false
      })

    // GET INTERVIEW QUESTIONS
    builder
      .addCase(getInterviewQuestions.pending, state => {
        state.loadingInterviewQ = true
      })
      .addCase(getInterviewQuestions.fulfilled, (state, action) => {
        state.loadingInterviewQ = false
        const { success, data, total_allow_time } = action.payload
        if (success) {
          state.interviewQuestions = data
          state.totalAllowTime = total_allow_time
        }
      })
      .addCase(getInterviewQuestions.rejected, (state, action) => {
        state.loadingInterviewQ = false
      })

    builder
      .addCase(submitInterviewAssessment.pending, state => {
        state.isLoading = true
      })
      .addCase(submitInterviewAssessment.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(submitInterviewAssessment.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
